import { useEffect, useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import { getToken, clearToken } from './lib/api';

export default function App() {
  const [token, setTokenState] = useState<string | null>(getToken());

  // Cross-tab sync — signing out in one tab logs out the others.
  useEffect(() => {
    const onStorage = () => setTokenState(getToken());
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (!token) return <Login onLogin={(t) => setTokenState(t)} />;

  return (
    <Dashboard
      onLogout={() => {
        clearToken();
        setTokenState(null);
      }}
    />
  );
}
